export default "__VITE_ASSET__3916f7f6__"